import React from "react";
import styles from "./ButtonIntro.module.scss";

function ButtonIntro({ icon, title, subtitle, theme = "green", onClick }) {
  const buttonClass = `${styles["card-button"]} ${styles[`theme--${theme}`]}`;

  return (
    <button className={buttonClass} onClick={onClick}>
      <div className={styles["icon-wrapper"]}>
        {icon}
      </div>
      <h3 className={styles["title"]}>{title}</h3>
      <p className={styles["subtitle"]}>{subtitle}</p>
    </button>
  );
}

export default ButtonIntro;